import { applicationStore } from './model';
import {
    SET_MEDIA_DEVICES_ENABLED,
    SET_MODAL_OPENING_COUNT,
    SET_REQUIRES_PERMISSION_REQUEST,
    SET_LANGUAGE,
    SET_LIGHT_REGISTRATION,
    SET_RETURN_TO,
} from './constants';

export function applicationReducer(state = applicationStore, action) {
    switch (action.type) {
        case SET_MEDIA_DEVICES_ENABLED:
            return {
                ...state,
                isMediaDevicesEnabled: action.payload,
            };

        case SET_MODAL_OPENING_COUNT:
            return {
                ...state,
                modalOpeningCount: action.payload,
            };

        case SET_REQUIRES_PERMISSION_REQUEST:
            return {
                ...state,
                requiresPermissionRequest: action.payload,
            };

        case SET_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            };

        case SET_LIGHT_REGISTRATION:
            return {
                ...state,
                isLightRegistration: action.payload,
            };

        case SET_RETURN_TO:
            return {
                ...state,
                returnTo: action.payload,
            };

        default:
            return state;
    }
}
